import { useMemo } from "react";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import NoContent from "../common/NoContent";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";

export default function BatchStudentsChecklist({ students = [], selectedUserIds = {}, onToggle, onCheckAll, disabled }) {
    const selectedCount = useMemo(() => Object.values(selectedUserIds).filter(Boolean).length, [selectedUserIds]);
    const allChecked = students.length > 0 && selectedCount === students.length;

    return (
        <div className="mt-4">
            <div className="flex align-items-center justify-content-between gap-2 mb-2">
                <span className={TEXT_SMALL}>
                    Selected {selectedCount} / {students.length}
                </span>
                <Button
                    label={allChecked ? "Uncheck all" : "Check all"}
                    size="small"
                    text
                    severity="secondary"
                    disabled={disabled || !students.length}
                    onClick={() => onCheckAll?.(!allChecked)}
                />
            </div>

            <div className="flex flex-column gap-2 overflow-y-auto" style={{ maxHeight: "220px" }}>
                {students.length ? (
                    students.map((student) => (
                        <div key={student.user_id} className="flex align-items-center gap-3 border-1 border-gray-300 border-round py-2 px-3">
                            <div className={`flex-1 ${TEXT_NORMAL} font-semibold`}>
                                {student.roll_no != null ? `${student.roll_no}. ` : null}
                                {student.full_name || "—"}
                            </div>
                            <Checkbox
                                inputId={`bulk-student-${student.user_id}`}
                                checked={!!selectedUserIds[student.user_id]}
                                onChange={(e) => onToggle?.(student.user_id, e.checked)}
                                disabled={disabled}
                            />
                        </div>
                    ))
                ) : (
                    <NoContent error="No Students In Batch" />
                )}
            </div>
        </div>
    );
}

export function toSelectedMap(students = [], checked = true) {
    return students.reduce((acc, student) => {
        acc[student.user_id] = checked;
        return acc;
    }, {});
}

export function getSelectedUserIds(selectedUserIds = {}) {
    return Object.entries(selectedUserIds)
        .filter(([, checked]) => checked)
        .map(([userId]) => Number(userId));
}
